<template>
  <div class="pt-5">
    <v-alert v-if="procesando" type="info" class="mb-4">
      Hay un proceso en ejecución... actualizando estado automáticamente. Espera
      a que termine para verificar el proceso.
      <v-progress-circular
        indeterminate
        size="14"
        width="2"
        color="white"
        class="mr-2"
      />
    </v-alert>

    <v-data-table
      :headers="headers"
      :items="jobs"
      :loading="loading"
      item-key="id"
      class="elevation-1"
      no-data-text="No hay procesos registrados"
      loading-text="Cargando histórico..."
    >
      <template #item.status="{ item }">
        <v-chip
          small
          dark
          :color="getStatusColor(item.status)"
          class="d-flex align-center justify-center"
        >
          <v-progress-circular
            v-if="item.status === 'PROCESSING'"
            indeterminate
            size="14"
            width="2"
            color="white"
            class="mr-2"
          />

          {{ getStatusDisplay(item) }}
        </v-chip>
      </template>

      <template #item.errores="{ item }">
        <div class="celda-errores justify-center">
          <span
            :class="{ 'text-red': item.errores > 0 }"
            @click="item.errores > 0 && abrirErrores(item)"
            class="numero-errores"
          >
            {{ item.errores }}
          </span>

          <v-icon
            v-if="item.errores > 0"
            small
            class="icono-ojo"
            @click="abrirErrores(item)"
          >
            mdi-eye
          </v-icon>
        </div>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogErrores" max-width="800">
      <v-card>
        <v-card-title>
          Detalle de errores - Archivo
          {{ jobSeleccionado ? jobSeleccionado.nombreArchivo : "" }}
        </v-card-title>

        <v-card-text>
          <v-data-table
            :headers="headersErrores"
            :items="erroresJob"
            :loading="loadingErrores"
            dense
            no-data-text="No hay errores registrados"
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialogErrores = false"
            dark
            color="#00a7e4"
            rounded
            class="mr-2"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { getAgenteAccessToken } from "@/services/tokens.service";
import { mainAxios } from "@/mainAxios";

export default {
  data() {
    return {
      jobs: [],
      loading: false,
      procesando: false,
      pollingInterval: null,
      headers: [
        { text: "ID", value: "id" },
        { text: "Alianza", value: "alianzaNombre" },
        { text: "Producto", value: "productoNombre" },
        { text: "Archivo", value: "nombreArchivo" },
        { text: "Inicio", value: "fechaInicio" },
        { text: "Fin", value: "fechaFin" },
        { text: "Accionado por", value: "agenteNombre" },
        { text: "Total Registros", value: "totalRegistros" },
        { text: "Procesados", value: "procesados" },
        { text: "Errores", value: "errores" },

        { text: "Status", value: "status" },
      ],
      dialogErrores: false,
      erroresJob: [],
      loadingErrores: false,
      jobSeleccionado: null,

      headersErrores: [
        { text: "Fila", value: "fila" },
        { text: "Mensaje", value: "mensaje" },
      ],
    };
  },

  async mounted() {
    await this.cargarHistorico();
    await this.verificarProcesandoInicial();
  },

  beforeDestroy() {
    this.detenerPolling();
  },

  methods: {
    async cargarHistorico() {
      this.loading = true;
      try {
        const response = await mainAxios.get(
          "/v1/emision/masivas/jobs/historico?proceso=EMISIONES",
          {
            headers: {
              Authorization: "Bearer " + getAgenteAccessToken(),
            },
          },
        );

        this.jobs = response.data;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async verificarProcesandoInicial() {
      try {
        const response = await mainAxios.get(
          "/v1/emision/masivas/jobs/procesando?proceso=EMISIONES",
          {
            headers: {
              Authorization: "Bearer " + getAgenteAccessToken(),
            },
          },
        );

        if (response.data && response.data.length > 0) {
          this.iniciarPolling();
        }
      } catch (error) {
        console.error(error);
      }
    },

    iniciarPolling() {
      if (this.pollingInterval) return;

      this.procesando = true;

      this.pollingInterval = setInterval(async () => {
        try {
          const response = await mainAxios.get(
            "/v1/emision/masivas/jobs/procesando?proceso=EMISIONES",
            {
              headers: {
                Authorization: "Bearer " + getAgenteAccessToken(),
              },
            },
          );

          if (!response.data || response.data.length === 0) {
            this.detenerPolling();
            await this.cargarHistorico();
            return;
          }

          const procesandoJobs = response.data;

          procesandoJobs.forEach((jobProcesando) => {
            const index = this.jobs.findIndex((j) => j.id === jobProcesando.id);

            if (index !== -1) {
              this.$set(this.jobs, index, jobProcesando);
            } else {
              this.jobs.unshift(jobProcesando);
            }
          });
        } catch (error) {
          console.error(error);
          this.detenerPolling();
        }
      }, 15000);
    },

    detenerPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
      this.procesando = false;
    },

    getStatusColor(status) {
      switch (status) {
        case "PROCESSING":
          return "blue";
        case "COMPLETED":
          return "green";
        case "COMPLETED_WITH_ERRORS":
          return "orange";
        case "FAILED":
          return "red";
        default:
          return "grey";
      }
    },
    getStatusDisplay(item) {
      if (item.status === "PROCESSING" && item.totalRegistros > 0) {
        const procesados = (item.procesados || 0) + (item.errores || 0);
        const porcentaje = Math.round((procesados / item.totalRegistros) * 100);
        return `Procesando ${porcentaje}%`;
      }

      switch (item.status) {
        case "COMPLETED":
          return "Completado";
        case "COMPLETED_WITH_ERRORS":
          return "Completado con errores";
        case "FAILED":
          return "Fallido";
        default:
          return item.status;
      }
    },
    async abrirErrores(job) {
      this.jobSeleccionado = job;
      this.dialogErrores = true;
      this.loadingErrores = true;
      this.erroresJob = [];

      try {
        const response = await mainAxios.get(
          `/v1/emision/masivas/jobs/${job.id}/errores`,
          {
            headers: {
              Authorization: "Bearer " + getAgenteAccessToken(),
            },
          },
        );

        this.erroresJob = response.data;
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingErrores = false;
      }
    },
  },
};
</script>

<style>
.celda-errores {
  position: relative;
  width: 100%;
}

.numero-errores {
  cursor: pointer;
}

.icono-ojo {
  position: absolute;
  cursor: pointer;
  opacity: 0.8;
}

.icono-ojo:hover {
  opacity: 1;
}
</style>
